<template>
  <div class="app">
    <ion-app>
    <router-view/>
    <!-- <ion-vue-router/> -->
  </ion-app>

  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { IonApp, IonRouterOutlet } from '@ionic/vue'

export default defineComponent({
    name: 'App',
    components: {
        IonApp,
        IonRouterOutlet,
    },
})
</script>

<style src='./theme.css'></style>